<template>
    <div>
        <div class="d-flex flex-column align-items-center bg-white pt-5 pb-4 pb-lg-4 px-3 mb-0 mb-lg-0">
            <div class="lazada-hc-logo mb-5"></div>
            <div class="container">
                <div class="d-flex justify-content-center mb-2">
                    <div class="p-2">
                        <h4 class="font-weight-bold">Unlock this feature <br />with Qwarta</h4>
                        <div class="font-sm text-secondary">
                            Keep using Qwarta to pay and <br />
                            settle your monthly dues to <br />
                            activate this feature!
                        </div>
                    </div>
                    <div class="p-2">
                        <img src="/img/user_restriction.svg" class="img-responsive" />
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center mb-2">
                    <div class="d-flex justify-content-center warning-sign rounded-sm col-10 p-2">
                        <div class="p-2">
                            <img src="/img/qwarta_icon_active.svg" class="img-responsive" />
                        </div>
                        <div class="p-2">
                            <div class="font-sm font-weight-bold mb-2">Pay your Qwarta bill on time</div>
                            <div class="font-xs text-secondary">
                                Don't forget to pay your monthly Qwarta dues! Check your billing statement for
                                <br />
                                the amount to be paid and due date.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                    <button 
                        type="button" 
                        @click="payQwarta" 
                        class="btn btn-green rounded-lg font-sm font-weight-bold py-3 mt-3 mb-5 col-10" 
                    >Pay Qwarta bill online</button>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column align-items-center bg-white mt-2 pb-4 pb-lg-4 px-3 mb-0 mb-lg-0">
            <div class="container pl-4">
                <div class="font-lg font-weight-bold p-2">Shop now with Qwarta</div>
                <div v-for="shopWithQwarta in shopWithQwartas" :key="shopWithQwarta.id" class="p-2">
                    <div class="d-flex justify-content-center align-items-center mb-2 col-12 col-sm-12 col-lg-12">
                        <div class="col-2 col-sm-2 col-lg-2 pl-4"><img :src="'/img/' + shopWithQwarta.image" class="img-responsive" /></div>
                        <div class="col-7">
                            <div class="font-md font-weight-bold">{{ shopWithQwarta.title }}</div>
                            <div class="font-xs text-secondary" v-html="shopWithQwarta.description"></div>
                        </div>
                        <div class="col-5 col-sm-5 col-lg-5 pr-5 text-right">
                            <a @click="shopQwarta(shopWithQwarta.id, shopWithQwarta.link)" class="success-text font-sm cursor-pointer fw-bold cursor-pointer">Learn More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column align-items-center bg-white mt-2 pb-4 pb-lg-4 px-3 mb-0 mb-lg-0">
            <div class="container pl-4">
                <div class="d-flex justify-content-center align-items-center mb-2 py-4">
                    <div class="pr-4 height-130">
                        <img src="/img/need_help.svg" class="img-responsive" />
                    </div>
                    <div>
                        <div class="font-md fw-bold mb-2">Need help?</div>
                        <div class="font-sm text-secondary">
                            If you are having issues with
                            <br />
                            activation, please let us know so we
                            <br />
                            can assist you.
                        </div>
                        <br />
                        <div class="font-md">
                            <a @click="contactUs" class="success-text font-md cursor-pointer fw-bold cursor-pointer">Contact Us <img src="/img/chevron_forward_outline.svg" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column align-items-center bg-white mt-2">
            <div class="container pl-4">
                <div class="d-flex justify-content-center align-items-center">
                    <div class="p-4">
                        <lazada-return id="mobileBackToStore">{{EnumLabels.CANCEL_AND_GOBACK_MERCHANT}}</lazada-return>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { EnumLabels } from '../enums/CommonString.js';
export default {
    data() {
        return {
            EnumLabels,
            oneIsActive: false,
            triggerEventName: "",
            link: "",
            shopWithQwartas: [
                {
                    id: 1,
                    title: "Buy Load",
                    image: "buy_load.png",
                    description: "Top up your load with less hassle",
                    link: "https://www.homecredit.ph/pay-with-home-credit/buy-load-online",
                },
                {
                    id: 2,
                    title: "Pay Bills",
                    image: "pay_bills.svg",
                    description: "Settle your bills online and set <br />payment reminders",
                    link: "https://www.homecredit.ph/pay-with-home-credit/pay-bills-online",
                },
                {
                    id: 3,
                    title: "Pay via QR or Barcode",
                    image: "barcode.svg",
                    description: "Shop and pay contactless at our partner stores",
                    link: "https://www.homecredit.ph/pay-with-home-credit/pay-with-qr",
                }
            ]
        }
    },
    methods: {
        payQwarta() {
            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': 'WT',
                'transaction_reference': this.$root.$data.referenceNumber,
            }       
            this.$root.triggerG4Event('click_pay_qwarta_bill_online',g4Params)
            window.open("https://www.homecredit.ph/pay-loans");
        },
        shopQwarta(shopWithQwartaId, shopWithQwartaLink) {
            
            if(shopWithQwartaId == 1) {
                this.link = shopWithQwartaLink;
                this.triggerEventName = "click_buy_load";
            } else if (shopWithQwartaId == 2) {
                this.link = shopWithQwartaLink;
                this.triggerEventName = "click_pay_bills";
            } else if (shopWithQwartaId == 3) {
                this.link = shopWithQwartaLink;
                this.triggerEventName = "click_pay_via_qr_or_barcode";
            }

            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': 'WT',
                'transaction_reference': this.$root.$data.referenceNumber,
            }       
            this.$root.triggerG4Event(this.triggerEventName,g4Params)
            window.open(this.link);
        },
        contactUs() {
            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': 'WT',
                'transaction_reference': this.$root.$data.referenceNumber,
            }       
            this.$root.triggerG4Event('click_contact_us',g4Params)
            window.open("https://www.homecredit.ph/contact-us");
        }
    }
}
</script>
<style scoped>
.lazada-hc-logo {
    /* Layout Properties */
    top: 14px;
    left: 36px;
    width: 100%;
    height: 52px;
    /* UI Properties */
    background: transparent url('/img/lazada/logos_desktop.png') center no-repeat padding-box;
    opacity: 1;
}
.modal-padding {
    padding: 5px;
}
.warning-sign {
    background-color: #FFF3E0;
}
.border-divider {
    border-bottom: solid 7px #F5F5F5;
}
.close-icon {
    color: #666666;
    font-size: 18px;
}
a {
    color: #000;
    
}
.collapse-header {
    overflow: hidden;
}
.card-title-collapse {
    background: #fff;
    padding: 12px 0 12px 12px;
    font-size: 16px;
    font-weight: bold;
    float: left;
    width: 90%;
}
.card-arrow-collapse {
    float: right;
    width: 10%;
    text-align: right;
    padding: 10px 12px 12px 12px;
}
.card-link[data-toggle="collapse"] b.arrow:before {
    content: "\f106";    /* angle-down */
    font-family: 'Font Awesome 5 Free';
}
.card-link[data-toggle="collapse"].collapsed b.arrow:before {
    content: "\f107";    /* angle-up */
    font-family: 'Font Awesome 5 Free';
}
.faq-link-content {
    color: #319E55;
    font-weight: bold;
}
.image-size-reponsive {
    width: 100%;
}
.cursor-pointer {
    cursor: pointer;
}
.height-130 {
    height: 130px;
}
.btn-green {
    color: #fff;
    background-color: #319E55;
    border-color: #49B672;
}
.success-text {
    color: #319E55;
}
</style>
